import { WorkerRequirementStatus } from "@clipboard-health/contract-worker-app-bff";
import { isDefined } from "@clipboard-health/util-ts";

import { useGetWorkerLicensesAllowedForDocuments } from "../useGetWorkerLicensesAllowedForDocuments";
import { useGetMandatoryWorkerRequirements } from "./wrappers/useGetMandatoryWorkerRequirements";

export function useHasActionRequiredForMandatoryRequirements() {
  const { licenses: availableLicenses, isLoaded: areLicensesLoaded } =
    useGetWorkerLicensesAllowedForDocuments();

  const { data: mandatoryRequirements } = useGetMandatoryWorkerRequirements(
    {
      qualifications: availableLicenses,
    },
    {
      enabled: areLicensesLoaded,
    }
  );

  const invalidWorkerRequirements = mandatoryRequirements?.filter(
    (requirement) =>
      !requirement.isValid && requirement.status !== WorkerRequirementStatus.IN_REVIEW
  );

  return isDefined(invalidWorkerRequirements) && invalidWorkerRequirements?.length > 0;
}
